import { Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { BalanceSheetSummary } from '../../types'

export const columns: (t: Function) => GridColDefVNW<BalanceSheetSummary>[] = (
    _t
) => [
    {
        field: 'report_month',
        headerName: 'month',
        width: 120,
        renderCell: ({ value }) => {
            const [year, month] = value.split('-')
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ]
            return (
                <div className="">
                    {monthNames[parseInt(month) - 1]} {year}
                </div>
            )
        },
    },
    {
        field: 'total_assets',
        headerName: 'total_assets',
        width: 180,
        align: 'right',
        renderCell: ({ value }) => (
            <Typogaphy>
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 0,
                }).format(value)}
            </Typogaphy>
        ),
    },
    {
        field: 'total_liability',
        headerName: 'total_liability',
        width: 180,
        align: 'right',
        renderCell: ({ value }) => (
            <Typogaphy>
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 0,
                }).format(value)}
            </Typogaphy>
        ),
    },
    {
        field: 'total_equity',
        headerName: 'total_equity',
        width: 180,
        align: 'right',
        renderCell: ({ value }) => (
            <Typogaphy>
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 0,
                }).format(value)}
            </Typogaphy>
        ),
    },
]
